import React from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Materials/RecentActivity.css';

const RecentActivity = ({ logs, hasMore, loading, onLoadMore }) => {

  const showEmpty = logs.length === 0 && !loading;

  return (
    <div className="material-tab-box">
      <h4 className="material-tab-box-title">Recent Activity</h4>
      {logs.length === 0 ? (
        <p className="material-tab-empty-msg">No activity yet</p>
      ) : (
        logs.map((log, idx) => (
          <div className={`material-tab-activity-log ${log.type}`} key={idx}>
            <p><strong>{log.date}</strong> : {log.message}</p>
          </div>
        ))
      )}


       {/* Inline Load More */}
          {(hasMore || loading) && (
            <button
              className="material-activity-load-more"
              disabled={loading}
              onClick={onLoadMore}
            >
              {loading ? 'Loading…' : 'Load more'}
            </button>
          )}
    </div>
  );
};

export default RecentActivity;
